import { AlertType } from '@domain/alerting/alerting.enums';

export const getTypeAsAlertType = (type: string): AlertType => type as AlertType;
